module.exports = __webpack_public_path__ + "img/parent4.246fa94c.png";